import React from 'react';
import { products } from '../../data/products';
import Hero from '../../components/Hero';
import ProductCard from '../../components/ProductCard';

const Accessories = () => {
  const accessories = products.filter(product =>
    product.name.toLowerCase().includes('switch') ||
    product.name.toLowerCase().includes('ups') ||
    product.name.toLowerCase().includes('media box')
  );

  return (
    <>
      <Hero
        title="Accesorii și Echipamente"
        subtitle="Echipamente și accesorii pentru rețeaua ta"
        backgroundImageUrl="/img/hero-cat-accessories.jpg"
      />
      <section className="py-20 px-4 bg-gray-50">
        <div className="container mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {accessories.map((product, index) => (
              <ProductCard key={product.id} product={product} index={index} />
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Accessories;
